import React, { useContext } from 'react';
import { AuthContext } from '../providers/AuthProvider';
import App from '../App';
import { ProductFruits } from 'react-product-fruits';

interface User {
  email?: string;
  firstName?: string;
  lastName?: string;
}

interface HelmetContextProps {
  helmetContext: Record<string, unknown>;
}

const AuthenticatedApp: React.FC<HelmetContextProps> = ({ helmetContext }) => {
  const auth = useContext(AuthContext);

  const extractUserInfo = (user: User) => ({
    username: user?.email || '',
    email: user?.email || '',
    firstname: user?.firstName || '',
    lastname: user?.lastName || '',
    role: 'user',
  });

  const userInfo = auth.user ? extractUserInfo(auth.user) : null;

  return (
    <React.Fragment>
      {userInfo && (
        <ProductFruits
          workspaceCode={process.env.REACT_APP_PRODUCT_FRUITS_CODE ?? ''} // dev: 4ogp1btjRqTX4go5 prod: qjHv3L0TYv6N6TWZ
          language="de"
          user={userInfo}
        />
      )}
      <App />
    </React.Fragment>
  );
};

export default AuthenticatedApp;
